import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';

import { List, Paper } from '@material-ui/core';
import { Button, H3, H4 } from '@blueprintjs/core';
import MTable from 'material-table';
import { CsvBuilder } from "filefy";
import { rounded } from '../../../utils.js'
import {estimatedClass} from '../common'
import { lemmaCat } from '../../../utils';
// import { PUBLIC_URL, ANALYTICS_URL } from '../../../constants.js';

import '../results.css';

//import CoocItem from './CoocItem';

// TODO : partitionner les wordsketch par réalisation ?

class WordSketchTab extends React.PureComponent {


  // calcLink = (query) => {
  //   const queryParams = "query=" + encodeURIComponent(query) + "&session_id=" + this.props.sessionId;
  //   return PUBLIC_URL + ANALYTICS_URL + "?" + queryParams;
  // }

  render() {
    const labels = this.props.ws;
    const {estimatedResults, t}= this.props;

    if (! labels) {
      return (
        <H4>{t('noResults')}</H4>
      );
    }

    const data=[];
    const tables=[];
    for (var catName of  Object.keys(labels).sort()) {
      data[catName]=[];
      // again, no way to generate a unique key out of this array
      for (var cooc of labels[catName]) {
        data[catName].push({
          collocate:lemmaCat(cooc[0]),
          numCooc:cooc[1],
          assoc:cooc[2],
          query:cooc[3]
        });
      }
      tables[catName] = (
        <MTable
          columns={[
            { field: 'collocate', 
              render: rowData => 
                <Button 
                  small={true}
                  minimal={true} 
                  onClick={()=>{ this.props.performSearch({query:rowData.query}); }}>{rowData.collocate}
                </Button> },
            { title:'freq',
              field: 'numCooc', 
              render: rowData => <span className={estimatedClass(rowData.numCooc,estimatedResults)}>{rounded(rowData.numCooc)}</span> ,
              cellStyle: {  fontSize:"small" },
              headerStyle: {  fontSize:"small"},

            },
            { title:'assoc',
              field: 'assoc', 
              defaultSort:'desc', 
              cellStyle: {  fontSize:"small" },
              headerStyle: { fontSize:"small"},
            } 
          ]}
          data={data[catName]}
          title={" "}
          options={{
            filtering: false,
            search: false,
            // sorting: true,
            exportButton: true,
            exportFileName: lemmaCat(this.props.query)+"_"+catName+"_wordsketch",
            exportAllData: true,
            padding: 'dense',
            paging: false,
            //headerStyle: {
            //  display:"none"
            //}
          }}
          components={{
            /* Pagination: props => (
              <TablePagination
                {...props}
                rowsPerPageOptions={[10, 25, data.length]}
              />
            ), */
            Container: props => (
              <Paper
                {...props}
                elevation={0}
              />
            ),
          }}
        />
      );     
    }

    // unfortunatly, no way to generate a unique key out of this array
    const labelLists = Object.keys(labels).sort().map(catName => {
      // again, no way to generate a unique key out of this array
      /* const coocs = labels[catName].map(cooc => (
        <CoocItem
          key={catName+" "+cooc[3]}
          collocate={cooc[0]}
          numCooc={cooc[1]}
          logLike={cooc[2]}
          query={cooc[3]}
        />
      )); */

      return (
        <Paper key={catName} style={{ margin: '1rem', flexShrink:'0', height: '30rem' }}>
          <List
            subheader={
              <div style={{
                padding: '1rem',
                textAlign: 'center',
                borderBottom: '1px solid #5C7080',
                height: '5rem'
              }}>
                <H3 style={{ margin: '0' }}>{catName}</H3>
              </div>
            }
            style={{ width: '22rem' }}
          >
            <div style={{overflow:'scroll', height:'25rem'}}> 
               {tables[catName]}
            </div>
          </List>
        </Paper>
      );
    });

    // For global tab only - give the detail for each realisation
    var labelListsByReal;
    if (this.props.wsByReal) {
      const labelsByReal = this.props.wsByReal;
 
      const data=[];
      const tablesByReal=[];
      const exportCsv= (columns, data) => {
        const fileName = lemmaCat(this.props.query)+"_wordsketch_by_realization";
        const builder = new CsvBuilder(
            fileName + ".csv"
        );
        const cols=Object.keys(data[0]);
        cols.pop();
        builder
            .setColumns(
              cols
            )
            .addRows(
              data.map((rowData) =>
                cols.map((col) => rowData[col])
            ))
            .exportFile();
      };      
      for (catName of  Object.keys(labelsByReal).sort()) {
        
        // create the header for catName
        const headerData=[];
        for (var j=0;j<labelsByReal[catName][0].length;j++) {
          const colloc=labelsByReal[catName][0][j];
          headerData.push( { 
            title: lemmaCat(colloc), 
            field: lemmaCat(colloc),
            cellStyle: { fontSize: 'smaller',padding:0 }
          })
        }
        // create the data table for catName
        data[catName]=[];
        for ( var i=1;i< labelsByReal[catName].length;i++ ) {
          const lineData={};
          for (j=0;j<labelsByReal[catName][i].length;j++) {
            lineData[lemmaCat(labelsByReal[catName][0][j])]=lemmaCat(labelsByReal[catName][i][j]);
          }
          data[catName].push(lineData);
        }
        tablesByReal[catName] = (
          <MTable
            columns={
              headerData
            }
            data={data[catName]}
            title={" "}
            options={{
              filtering: false,
              search: false,
              exportButton: true,
              //exportFileName: lemmaCat(this.props.query)+"_"+catName+"_wordsketch_by_realization",
              exportAllData: false,
              exportCsv: exportCsv,
              padding: 'dense',
              paging: false,
              headerStyle: {
                fontWeight:"bolder",
                fontSize:"larger"
              }
            }}
            components={{
       
              Container: props => (
                <Paper
                  {...props}
                  elevation={0}
                />
              ),
            }}
          />
        );     
      }
  
      // unfortunatly, no way to generate a unique key out of this array
      labelListsByReal = Object.keys(labelsByReal).sort().map(catName => {

  
        return (
          <Paper key={catName+"_by_real"} style={{ margin: '1rem', flexShrink:'0', height: '30rem' }}>
            <List
              subheader={
                <div style={{
                  padding: '1rem',
                  textAlign: 'center',
                  borderBottom: '1px solid #5C7080',
                  height: '5rem'
                }}>
                  <H3 style={{ margin: '0' }}>{catName}</H3>
                </div>
              }
              style={{ width: '40rem' }}
            >
              <div style={{overflow:'scroll', height:'25rem'}}> 
                 {tablesByReal[catName]}
              </div>
            </List>
          </Paper>
        );
      });

    }

    return (
      <>
        { this.props.displayName &&
          <div style={{color:"green",marginBottom:"20px"}}>{t('subCorpusName')} : {this.props.name}</div>
        } 
        <div
          className="flex"
          style={{ overflowX: 'auto' }}
        >
          {labelLists}
        </div>
        { this.props.wsByReal &&
          <>
            <div>
              <br/>
              <H4>{t('wsByRealization')}</H4>
            </div>
            <div
              className="flex"
              style={{ overflowX: 'auto' }}
            >
              
              {labelListsByReal}
            </div>
          </>
        }
      </>
    );
  }
}

WordSketchTab.propTypes = {
  name: PropTypes.string,
  displayName : PropTypes.bool,
  // look at Results.wordSketchData for an example
  ws: PropTypes.any,
  wsByReal: PropTypes.object, // only for global tab
  query : PropTypes.string,
  estimatedResults:PropTypes.bool,
  sessionId: PropTypes.string,
  performSearch: PropTypes.func,
};

export default withTranslation()(WordSketchTab);